import { useEffect, useRef, type RefObject } from 'react';

/**
 * Um botão "Tentar de novo" que dá lugar ao conteúdo quando a busca dá certo deixa o foco no <body>.
 * `arm()` (ao clicar) marca que o foco precisa ser resgatado; quando `ready` vira verdadeiro, ele vai
 * para `target`, MAS só se tiver se perdido de fato: a pessoa pode ter ido clicar em outro botão
 * enquanto esperava, e roubar o foco dela seria pior.
 */
export function useFocusRescue(
  ready: boolean,
  target: RefObject<HTMLElement | null>,
): { arm: () => void; disarm: () => void } {
  const armed = useRef(false);

  useEffect(() => {
    if (!armed.current || !ready) return;
    armed.current = false;
    if (document.activeElement === document.body) target.current?.focus();
  }, [ready, target]);

  return {
    arm: () => {
      armed.current = true;
    },
    disarm: () => {
      armed.current = false;
    },
  };
}
